module.exports = __webpack_public_path__ + "img/product-package-one.ee82263.png";